/* i18n : chaînes servies par window.TL_I18N (layout/theme.liquid, depuis locales/*.json).
   Le littéral français reste en repli si le blob manque (script chargé hors thème). */
function tlT(k, fallback) { return (window.TL_I18N && window.TL_I18N[k]) || fallback; }

/* Pays où un numéro de TVA intracommunautaire existe : les 27 États membres, plus Monaco
   (les entreprises monégasques portent un numéro FR). Ailleurs — Ouzbékistan, Suisse,
   Royaume-Uni… — le champ TVA n'a pas d'équivalent, donc il ne peut pas être exigé. */
const TLRR_VAT_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','MC','NL','PL','PT','RO','SK','SI','ES','SE'];

/* Tiloli — B2B reseller registration.
   Posts JSON to the NAV SYNC App Proxy (/apps/b2b/register, same-origin, Shopify auto-signs).
   No password fields (store = NEW_CUSTOMER_ACCOUNTS, passwordless). Phone is required (unique in Shopify). */
class TiloliRegister extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.endpoint = this.getAttribute('data-endpoint') || '/apps/b2b/register';
    this.btn = this.querySelector('[data-submit]');
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
    this.form.addEventListener('input', (e) => this.clearFieldError(e.target));
    this.form.addEventListener('change', (e) => this.clearFieldError(e.target));
    this.initPlaces();
    this.initPhones();
    this.initLivraison();
    this.initVatRule();
  }

  /* La TVA intracommunautaire n'existe que dans l'UE. Le champ reste affiché hors UE (un
     identifiant fiscal local est utile à l'ADV) mais cesse d'être obligatoire, sinon le
     prospect hors UE doit inventer un numéro pour passer la validation. Le réglage de
     section reste souverain : si la TVA n'était pas obligatoire, elle ne le devient pas. */
  initVatRule() {
    const vat = this.form.elements['vat'];
    const pays = this.form.elements['pays'];
    if (!vat || !pays) return;
    const requiredInEu = vat.required;
    const mark = this.fieldOf(vat).querySelector('[data-req-mark]');
    const apply = () => {
      const inEu = TLRR_VAT_COUNTRIES.indexOf((pays.value || '').toUpperCase()) !== -1;
      vat.required = requiredInEu && inEu;
      if (mark) mark.hidden = !vat.required;
      if (!vat.required) this.clearFieldError(vat);
    };
    pays.addEventListener('change', apply);
    apply();
  }

  /* CreateAccountV2 (#190) — vraie adresse de livraison (NAV crée un Ship-to Address).
     Cochée (défaut) = identique à l'adresse principale : champs désactivés/cachés, le
     backend copie l'adresse de facturation. Décochée → champs actifs (+ validés). */
  initLivraison() {
    this.livrSame = this.form.querySelector('[data-livr-same]');
    this.livrAddress = this.querySelector('[data-livr-address]');
    if (!this.livrSame || !this.livrAddress) return;
    const apply = () => {
      const same = this.livrSame.checked;
      this.livrAddress.hidden = same;
      this.livrAddress.querySelectorAll('input').forEach((el) => {
        el.disabled = same;
        if (same) this.clearFieldError(el);
      });
    };
    this.livrSame.addEventListener('change', apply);
    apply();
  }

  /* Indicatifs pays sur les champs tel (intl-tel-input, auto-hébergé). separateDialCode → l'indicatif
     est affiché à part ; au submit on normalise en E.164 (+33…) via getNumber() (utils chargé en async).
     Fallback si utils pas prêt : indicatif + chiffres (sans 0 initial). */
  initPhones() {
    if (this.getAttribute('data-phone-intl') !== 'true' || !window.intlTelInput) return;
    const utils = this.getAttribute('data-iti-utils') || undefined;
    const country = this.getAttribute('data-iti-country') || 'fr';
    this._itis = [];
    this.form.querySelectorAll('input[type="tel"]').forEach((input) => {
      const iti = window.intlTelInput(input, {
        initialCountry: country,
        preferredCountries: ['fr', 'es', 'pt'],
        separateDialCode: true,
        utilsScript: utils,
      });
      // en tapant, on efface l'état d'erreur custom (la bulle se re-valide au prochain submit)
      input.addEventListener('input', () => input.setCustomValidity(''));
      this._itis.push({ input, iti });
    });
  }

  /* Marque les tels mal formés (ex. chiffre manquant) via setCustomValidity → reportValidity()
     pointe le champ fautif. Requiert utils chargé (window.intlTelInputUtils) ; sinon on n'invalide pas. */
  validatePhones() {
    if (!this._itis || !window.intlTelInputUtils) return;
    this._itis.forEach(({ input, iti }) => {
      input.setCustomValidity('');
      if (!input.value.trim()) return; // vide → géré par `required`
      if (typeof iti.isValidNumber === 'function' && !iti.isValidNumber()) {
        input.setCustomValidity(this.getAttribute('data-iti-error') || 'Numéro de téléphone invalide.');
      }
    });
  }

  // --- Validation inline (message rouge sous le champ + bordure rouge), pas de bulle native ---
  fieldOf(el) { return el.closest('.tlrr__field') || el.parentNode; }
  showFieldError(el, msg) {
    const field = this.fieldOf(el);
    field.classList.add('is-error');
    let err = field.querySelector('.tlrr__field-error');
    if (!err) { err = document.createElement('span'); err.className = 'tlrr__field-error'; field.appendChild(err); }
    err.textContent = msg;
  }
  clearFieldError(el) {
    if (!el) return;
    const field = this.fieldOf(el);
    if (!field || !field.classList) return;
    field.classList.remove('is-error');
    const err = field.querySelector('.tlrr__field-error');
    if (err) err.remove();
  }
  validateAll() {
    this.validatePhones();
    let first = null;
    this.form.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.type === 'hidden' || el.disabled || el.name === 'acceptsMarketing' || el.name === 'livr_same') return;
      if (el.checkValidity()) { this.clearFieldError(el); return; }
      let msg = el.validationMessage;
      if (el.validity.valueMissing) msg = tlT('regRequired', 'Ce champ est obligatoire.');
      else if (el.validity.typeMismatch && el.type === 'email') msg = tlT('regEmailInvalid', 'Adresse e-mail invalide.');
      this.showFieldError(el, msg);
      if (!first) first = el;
    });
    if (first) { try { first.focus(); } catch (e) {} first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return !first;
  }

  normalizePhones() {
    if (!this._itis) return;
    this._itis.forEach(({ input, iti }) => {
      if (!input.value.trim()) return;
      let num = '';
      try { num = iti.getNumber(); } catch (e) { /* utils pas prêt */ }
      if (!num) {
        const cc = iti.getSelectedCountryData();
        const digits = input.value.replace(/\D/g, '').replace(/^0+/, '');
        if (cc && cc.dialCode && digits) num = '+' + cc.dialCode + digits;
      }
      if (num) input.value = num;
    });
  }

  /* Autocomplétion d'adresse Google Places sur le champ `rue1`. Clé + pays via data-attrs
     (réglages de section). Au choix d'une suggestion → remplit rue1/cp/ville/region/pays.
     Requiert « Places API » activée sur la clé (restreinte par referrer). Vide = champ normal.
     Charge l'API une seule fois pour toute la page (callback global mutualisé). */
  initPlaces() {
    const key = this.getAttribute('data-places-key');
    const input = this.form.elements['rue1'];
    if (!key || !input) return;
    this._placesCountry = (this.getAttribute('data-places-country') || '').trim().toLowerCase();
    const ready = () => this.bindAutocomplete(input);
    if (window.google && window.google.maps && window.google.maps.places) { ready(); return; }
    (window.__tlPlacesCbs = window.__tlPlacesCbs || []).push(ready);
    if (window.__tlPlacesLoading) return;
    window.__tlPlacesLoading = true;
    window.__tlPlacesInit = () => { (window.__tlPlacesCbs || []).forEach((fn) => fn()); window.__tlPlacesCbs = []; };
    const sc = document.createElement('script');
    sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&libraries=places&loading=async&callback=__tlPlacesInit';
    sc.async = true;
    document.head.appendChild(sc);
  }

  async bindAutocomplete(input) {
    // Places API (New) : PlaceAutocompleteElement (l'Autocomplete classique est bloqué pour les
    // nouveaux projets Google). L'élément rend son PROPRE champ → on l'insère en « Rechercher
    // l'adresse » au-dessus du champ rue1 ; au choix → on remplit les champs structurés.
    let PlaceAutocompleteElement;
    try { ({ PlaceAutocompleteElement } = await google.maps.importLibrary('places')); }
    catch (e) { return; }
    if (!PlaceAutocompleteElement) return;

    const opts = {};
    if (this._placesCountry) opts.includedRegionCodes = [this._placesCountry];
    let pac;
    try { pac = new PlaceAutocompleteElement(opts); }
    catch (e) { return; }
    // Aligne le champ Google (son input interne est transparent → on stylise le :host) sur les
    // autres champs du form : crème, sans bord, radius 12, clair (colorScheme light sinon dark-mode OS → noir).
    pac.style.cssText = 'width:100%;color-scheme:light;background:var(--tl-cream);border:0;border-radius:var(--tl-r-md,12px);min-height:46px;font-family:var(--tl-body);';

    const field = document.createElement('label');
    field.className = 'tlrr__field tlrr__field--full tlrr__field--places';
    const lbl = document.createElement('span');
    lbl.className = 'tlrr__label';
    lbl.textContent = this.getAttribute('data-places-label') || 'Rechercher l’adresse';
    field.appendChild(lbl);
    field.appendChild(pac);
    const rueField = input.closest('.tlrr__field') || input.parentNode;
    rueField.parentNode.insertBefore(field, rueField);

    pac.addEventListener('gmp-select', async (event) => {
      const pred = event.placePrediction;
      if (!pred) return;
      const place = pred.toPlace();
      try { await place.fetchFields({ fields: ['addressComponents'] }); }
      catch (e) { return; }
      this.fillAddress(place.addressComponents || []);
    });
  }

  fillAddress(components) {
    // Nouveau format : { types:[...], longText, shortText }. Tolère l'ancien (long_name).
    const get = (type) => {
      const c = components.find((x) => (x.types || []).indexOf(type) !== -1);
      return c ? (c.longText || c.long_name || '') : '';
    };
    // ISO alpha-2 (shortText) for a component — the `pays` field is now a
    // code-valued <select>, so the country must be the code (e.g. 'FR'), not the
    // long name. A code outside our option list won't match and leaves the select
    // empty → `required` makes the user pick manually.
    const getCode = (type) => {
      const c = components.find((x) => (x.types || []).indexOf(type) !== -1);
      return c ? (c.shortText || c.short_name || '').toUpperCase() : '';
    };
    // `change` est émis à la main : une écriture programmatique n'en déclenche aucun, et
    // la règle TVA (UE ou non) écoute le pays.
    const set = (name, val) => {
      const el = this.form.elements[name];
      if (!el || !val) return;
      el.value = val;
      el.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const rue1 = [get('street_number'), get('route')].filter(Boolean).join(' ');
    if (rue1) set('rue1', rue1);
    set('cp', get('postal_code'));
    set('ville', get('locality') || get('postal_town'));
    set('region', get('administrative_area_level_1'));
    set('pays', getCode('country'));
  }

  val(name) {
    const el = this.form.elements[name];
    return el ? el.value.trim() : '';
  }

  onSubmit(e) {
    e.preventDefault();
    if (!this.validateAll()) return;
    this.normalizePhones();
    const nl = this.form.elements['acceptsMarketing'];
    const body = {
      email: this.val('email'),
      acceptsMarketing: nl ? nl.checked : false,
      registration: {
        raisonSociale: this.val('raisonSociale'),
        nom: this.val('nom'),
        prenom: this.val('prenom'),
        telephone: this.val('telephone'),
        vat: this.val('vat'),
        typeActivite: this.val('typeActivite'),
        rue1: this.val('rue1'),
        rue2: this.val('rue2'),
        cp: this.val('cp'),
        ville: this.val('ville'),
        pays: this.val('pays'),
        region: this.val('region'),
        statutJuridique: this.val('statutJuridique'),
        // Question ouverte facultative (2026-08-11). Bloc masqué en back-office ou
        // laissé vide → chaîne vide, comme les autres champs : le backend et la carte
        // Teams traitent '' comme « pas de réponse » (aucun bloc affiché).
        presentation: this.val('presentation'),
        contactCompta: {
          nom: this.val('compta_nom'),
          prenom: this.val('compta_prenom'),
          email: this.val('compta_email'),
          tel: this.val('compta_tel'),
        },
        // CreateAccountV2 (#190) : contact livraison + vraie adresse. Case « identique »
        // cochée → on omet l'adresse ; le backend copie alors l'adresse principale
        // (livraison sans adresse1 = copie facturation, cf. contrat b2b_registration).
        livraison: Object.assign(
          {
            nom: this.val('livr_nom'),
            prenom: this.val('livr_prenom'),
            email: this.val('livr_email'),
            tel: this.val('livr_tel'),
          },
          this.livrSame && !this.livrSame.checked
            ? {
                adresse1: this.val('livr_adresse1'),
                adresse2: this.val('livr_adresse2'),
                codePostal: this.val('livr_cp'),
                ville: this.val('livr_ville'),
                pays: this.val('livr_pays'),
              }
            : {}
        ),
      },
    };
    this.submit(body);
  }

  async submit(body) {
    this.setBusy(true);
    let res;
    let data = {};
    try {
      res = await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      try { data = await res.json(); } catch (_) { /* non-JSON (e.g. /password redirect) */ }
    } catch (_) {
      this.show('error');
      this.setBusy(false);
      return;
    }

    /* L'intake distingue déjà les cas côté serveur ; tout statut non traité ici retombait
       sur « une erreur est survenue », donc un prospect dont la demande était DÉJÀ en cours
       relançait le formulaire en boucle en croyant le site cassé (constaté en prod le
       31/08/2026 : trois POST 200 en deux minutes, aucun enregistrement créé). */
    const status = res.ok && data && data.ok ? data.status : '';
    if (status === 'pending') {
      this.show('pending');
    } else if (status === 'already-pending') {
      /* Demande déjà déposée mais pas encore tranchée : ce n'est PAS « vous avez déjà un
         compte », sinon le prospect va chercher à se connecter à un compte qui n'existe
         pas encore. */
      this.show('already-pending');
    } else if (status === 'already-registered' || status === 'already-active') {
      this.show('already');
    } else if (status === 'declined') {
      this.show('declined');
    } else {
      this.show('error');
    }
    this.setBusy(false);
  }

  setBusy(busy) {
    if (!this.btn) return;
    this.btn.disabled = busy;
    this.btn.classList.toggle('is-busy', busy);
  }

  show(kind) {
    // kind: 'pending' | 'already' | 'already-pending' | 'declined' | 'error'
    const replacesForm = kind !== 'error';
    this.querySelectorAll('[data-msg]').forEach((m) => {
      m.hidden = m.getAttribute('data-msg') !== kind;
    });
    if (this.form) this.form.hidden = replacesForm;
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
customElements.define('tiloli-register', TiloliRegister);
